<template>
<el-tooltip :content="tooltip" :placement="tooltipPlacement" :open-delay="MapConst.TOOLTIP_DELAY" :disabled="tooltip === ''">
  <div v-if="type === 'img'" :class="['topology-align-tool', 'map-button', cls, (disabled ? $style.disabled : '')]" @click="onClick"></div>
  <el-button v-else-if="type === 'button'" size="medium" type="content" :class="[icon, 'map-button', cls]" @click="onClick" :disabled="disabled"></el-button>
</el-tooltip>
</template>

<script>
import MapConst from '@/constants/topologymap';

export default {
  name: 'WMapButton',
  props: {
    /**
     * 버튼 이미지 class명
     */
    icon: {
      type: String,
    },
    /**
     * 버튼 타입 (image or button)
     * @type {Object}
     */
    type: {
      type: String,
      default: 'img',
    },
    /**
     * 토글 여부
     */
    toggle: {
      type: Boolean,
      default: false,
    },
    /**
     * 토글 상태
     * @type {Object}
     */
    pressed: {
      type: Boolean,
      default: false,
    },
    /**
     * 툴팁 내용
     * @type {Object}
     */
    tooltip: {
      type: String,
      default: '',
    },
    /**
     * 툴팁 위치
     */
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
    /**
     * 활성화 여부
     * @type {Object}
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MapConst,
      selected: this.pressed,
    };
  },
  computed: {
    cls() {
      const c = {};
      c[this.icon] = true;
      c.selected = this.selected;
      return c;
    },
  },
  watch: {
    pressed(value) {
      this.selected = value;
    },
  },
  methods: {
    /**
     * 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    onClick(evt) {
      // 비활성화 상태이면 수행하지 않음
      if (this.disabled) {
        return;
      }

      // 토글이면 토글 상태 반전
      if (this.toggle) {
        this.selected = !this.selected;
      }
      this.$emit('onClick', this, evt);
    },
  },
};
</script>
<style lang="scss">
.map-button{
  cursor: pointer;
}
</style>

<style module>
.disabled {
  opacity: 0.2;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapButton.vue